import { IconAngleRight, mapper } from '@maia/icons';
import { InsuranceDto } from '@maia/shared';
import { ActionButtonLink, FeaturedIcon, Typography, Widget } from '@maia/ui';
import { formatDate } from '@maia/utils';

type InsuranceCardProps = {
  insurance: InsuranceDto;
};

export function RecentlyClosedInsuranceCard(props: InsuranceCardProps) {
  const { insurance } = props;

  return (
    <Widget
      title={insurance.title}
      icon={
        <FeaturedIcon
          icon={mapper(insurance.icon)}
          variant="light-square"
          size="sm"
        />
      }
      subtitle={insurance.customer.consumer.fullName}
      actions={[
        <ActionButtonLink
          icon={IconAngleRight}
          size="small"
          to={`/insurances/${insurance.guid}`}
        />,
      ]}
      padding="large"
    >
      <Typography
        variant="body-xs"
        weight="regular"
        className="text-grayscale300"
      >
        {formatDate(insurance.createdAt)}
      </Typography>
      <Typography variant="body-xs" weight="medium" className="text-info300">
        {`#${insurance.reference}`}
      </Typography>
    </Widget>
  );
}
